<template>
  <Grid v-if="!chart" place-items="center" class="card-with-custom-chart bg-white-1 shadow3">
    <q-spinner color="primary" size="2em" />
  </Grid>

  <Grid v-else gtc="1fr 1fr" gap="20px" class="card-with-custom-chart bg-white-1 shadow3 q-pa-lg q-pr-lg">
    <Grid gtr="auto 1fr" gap="var(--r-space-xxl)" class="q-pr-lg">
      <div class="title">
        <div class="text-secondary-1 text-heading-2">{{ title }}</div>
        <div class="text-secondary-5 text-caption-3">{{ subtitle }}</div>
      </div>

      <div class="chart-wrapper">
        <CustomChart :chart-data="chart" />
      </div>
    </Grid>

    <Grid align-content="space-between" class="q-pl-xl">
      <Grid gap="var(--r-space-sm)" align-content="start" class="info-top text-right q-pt-sm">
        <slot name="info-top"></slot>
      </Grid>

      <Grid gap="var(--r-space-sm)" class="info-bottom text-right text-secondary-1">
        <slot name="info-bottom"></slot>
      </Grid>
    </Grid>
  </Grid>
</template>

<script>
import CustomChart from '../custom-chart/CustomChart'

export default {
  components: {
    CustomChart
  },

  props: {
    chart: { required: true },
    title: String,
    subtitle: String
  }
}
</script>

<style lang="scss" scoped>
.card-with-custom-chart {
  height: 340px;

  .chart-wrapper {
    height: 190px;
  }
}
</style>
